import { appSelectors } from '@appStore/reducers/app'
import { FullLoader } from 'components/atoms/FullLoader/FullLoader'
import { useReactOnLinkedInStatus } from 'features/linked-in-status'
import { NotificationUI } from 'features/notifications'
import { AuthController } from 'features/onboard'
import { useRejectPromise } from 'pages/error'
import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'

import { connectorAPI } from '../../actions/connector'
import { useAppSelector } from '../../shared/hooks/index'

export function AuthWrapper() {
	const auth = useAppSelector(appSelectors.auth)
	const connector = useAppSelector(appSelectors.connector)
	const isReadyConnector = useAppSelector(appSelectors.isReadyConnector)

	// biome-ignore lint/correctness/useExhaustiveDependencies: old code, not sure
	useEffect(() => {
		if (isReadyConnector) {
			connectorAPI.setUpInit()
		}
	}, [connector, auth])

	useReactOnLinkedInStatus()
	useRejectPromise()

	switch (auth) {
		case 'auth':
			return (
				<>
					<Outlet />
					<NotificationUI.Snackbar />
				</>
			)

		case 'none':
			return <AuthController />

		default:
			return <FullLoader />
	}
}
